export default __webpack_public_path__ + "static/media/detail_mobile_16_3.222cfcdd.jpg";